import { combineReducers } from '@reduxjs/toolkit'
import progress from './Monitoramento.progress'
import listDates from './Monitoramento.listDates'
import dataDetails from './Monitoramento.dataDetails'

export const useMonitoramento = () => {
  const monitoramentoReducer = combineReducers({ progress, listDates, dataDetails })
  return { monitoramentoReducer }
}
